<template>
  <div>
    <small class="text-muted d-block mb-1">ไม่เลือก = ใช้ได้ทุกสาขา</small>
    <b-input-group>
      <multiselect
        class="col p-0"
        v-model="selectedBranchObjects"
        :options="branchOptions"
        :multiple="true"
        :close-on-select="false"
        placeholder="ค้นหาสาขา"
        label="text"
        track-by="value"
        selectLabel=""
        selectedLabel=""
        deselectLabel=""
        @input="onSelectionChange"
      >
        <span slot="noResult">ไม่พบสาขา</span>
      </multiselect>
      <b-input-group-append>
        <b-button variant="outline-secondary" @click="showBrowseModal">
          <i class="fas fa-list"></i>
        </b-button>
      </b-input-group-append>
    </b-input-group>

    <!-- Browse Modal -->
    <b-modal
      ref="browseModal"
      title="เลือกสาขา"
      ok-title="ตกลง"
      cancel-title="ยกเลิก"
      @ok="applyBrowseSelection"
      @show="initBrowseSelection"
      modal-class="picker-modal"
    >
      <div class="picker-search mb-2">
        <i class="fas fa-search picker-search-icon"></i>
        <b-form-input
          v-model="browseFilter"
          type="search"
          placeholder="ค้นหาสาขา..."
          class="picker-search-input"
          autofocus
        />
      </div>
      <div class="d-flex justify-content-between align-items-center mb-2">
        <div>
          <b-badge variant="primary" pill class="px-2 py-1">
            <i class="fas fa-check mr-1"></i>{{ browseSelected.length }}
          </b-badge>
          <small class="text-muted ml-1">/ {{ filteredBranchOptions.length }} สาขา</small>
        </div>
        <div>
          <b-button size="sm" variant="outline-primary" @click="selectAllBranches" class="mr-1 btn-picker">
            <i class="fas fa-check-double mr-1"></i>เลือกทั้งหมด
          </b-button>
          <b-button size="sm" variant="outline-secondary" @click="deselectAllBranches" class="btn-picker">
            <i class="fas fa-times mr-1"></i>ล้าง
          </b-button>
        </div>
      </div>
      <div class="picker-list-container">
        <div v-if="filteredBranchOptions.length === 0" class="text-center py-4 text-muted">
          <i class="fas fa-store-slash fa-2x mb-2 d-block"></i>
          <span>ไม่พบสาขา</span>
        </div>
        <div v-else class="picker-category-section">
          <div class="picker-category-header">
            <i class="fas fa-store mr-1"></i> สาขาทั้งหมด
            <b-badge variant="light" pill class="ml-1">{{ filteredBranchOptions.length }}</b-badge>
          </div>
          <div class="picker-items">
            <b-form-checkbox
              v-for="branch in filteredBranchOptions"
              :key="branch.value"
              v-model="browseSelected"
              :value="branch.value"
              class="picker-item"
            >
              <i class="fas fa-code-branch text-muted mr-1" style="font-size: 0.75rem"></i>
              {{ branch.text }}
            </b-form-checkbox>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Multiselect from "vue-multiselect";

export default {
  name: "BranchPicker",
  components: { Multiselect },
  props: {
    value: { type: Array, default: null },
  },
  data() {
    return {
      selectedBranchObjects: [],
      browseFilter: "",
      browseSelected: [],
    };
  },
  computed: {
    ...mapGetters("moduleUser", ["getClinicList", "getBranchInfo"]),
    branchOptions() {
      if (!this.getClinicList) return [];
      const clinic = this.getClinicList.find(
        c => c.id === this.getBranchInfo?.clinic?.id
      );
      if (!clinic || !clinic.branches) return [];
      return clinic.branches.map(b => ({
        text: b.name,
        value: b.id,
      }));
    },
    filteredBranchOptions() {
      if (!this.browseFilter) return this.branchOptions;
      const q = this.browseFilter.toLowerCase();
      return this.branchOptions.filter(b =>
        b.text.toLowerCase().includes(q)
      );
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.syncFromValue(val);
      },
    },
    branchOptions() {
      this.syncFromValue(this.value);
    },
  },
  mounted() {
    this.fetchClinicList();
  },
  methods: {
    ...mapActions("moduleUser", ["fetchClinicList"]),
    syncFromValue(val) {
      if (!val || val.length === 0) {
        this.selectedBranchObjects = [];
        return;
      }
      this.selectedBranchObjects = this.branchOptions.filter(b =>
        val.includes(b.value)
      );
    },
    onSelectionChange(newVal) {
      const ids = (newVal || []).map(b => b.value);
      this.$emit("input", ids.length > 0 ? ids : null);
    },
    showBrowseModal() {
      this.$refs.browseModal.show();
    },
    initBrowseSelection() {
      this.browseFilter = "";
      this.browseSelected = this.value || [];
    },
    applyBrowseSelection() {
      const ids = this.browseSelected;
      this.$emit("input", ids.length > 0 ? ids : null);
      this.selectedBranchObjects = this.branchOptions.filter(b =>
        ids.includes(b.value)
      );
    },
    selectAllBranches() {
      this.browseSelected = this.filteredBranchOptions.map(b => b.value);
    },
    deselectAllBranches() {
      this.browseSelected = [];
    },
  },
};
</script>

<style scoped>
.picker-search {
  position: relative;
}
.picker-search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #adb5bd;
  font-size: 0.85rem;
  z-index: 1;
}
.picker-search-input {
  padding-left: 2.2rem;
  border-radius: 8px;
}
.btn-picker {
  border-radius: 6px;
  font-size: 0.78rem;
  padding: 0.25rem 0.6rem;
}
.picker-list-container {
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fafbfc;
}
.picker-category-header {
  background: linear-gradient(135deg, #e8f4fd, #dbeafe);
  color: #1e60a0;
  font-weight: 600;
  font-size: 0.82rem;
  padding: 0.5rem 0.75rem;
  border-bottom: 1px solid #e2e8f0;
  position: sticky;
  top: 0;
  z-index: 1;
}
.picker-items {
  padding: 0.35rem 0.35rem 0.35rem 0;
}
.picker-item {
  padding: 0.35rem 0.75rem;
  padding-left: 2rem;
  margin: 0;
  transition: background 0.15s;
  font-size: 0.88rem;
}
.picker-item:hover {
  background: #eef4fb;
}
.picker-item >>> .custom-control-label::before,
.picker-item >>> .custom-control-label::after {
  left: -1.4rem;
}
</style>
